export default __webpack_public_path__ + "static/media/notificationRefresh.5cb8852a.svg";